/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteTrainingProjectMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteTrainingProjectMutation = { __typename?: 'Mutation', deleteTrainingProject: { __typename?: 'DeleteTrainingProject', ok: boolean | null | undefined } | null | undefined };


export const DeleteTrainingProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTrainingProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteTrainingProject"},"name":{"kind":"Name","value":"delete_training_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"training_project_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteTrainingProjectMutation, DeleteTrainingProjectMutationVariables>;
export const namedOperations = {
  Mutation: {
    DeleteTrainingProject: 'DeleteTrainingProject'
  }
}

export type DeleteTrainingProjectMutationFn = Apollo.MutationFunction<DeleteTrainingProjectMutation, DeleteTrainingProjectMutationVariables>;

/**
 * __useDeleteTrainingProjectMutation__
 *
 * To run a mutation, you first call `useDeleteTrainingProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainingProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainingProjectMutation, { data, loading, error }] = useDeleteTrainingProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainingProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainingProjectMutation, DeleteTrainingProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainingProjectMutation, DeleteTrainingProjectMutationVariables>(DeleteTrainingProjectDocument, options);
      }
export type DeleteTrainingProjectMutationHookResult = ReturnType<typeof useDeleteTrainingProjectMutation>;
export type DeleteTrainingProjectMutationResult = Apollo.MutationResult<DeleteTrainingProjectMutation>;
export type DeleteTrainingProjectMutationOptions = Apollo.BaseMutationOptions<DeleteTrainingProjectMutation, DeleteTrainingProjectMutationVariables>;